import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledArticleTemplateContentComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .article-items-list {
    margin: 72px 0 64px 0;
    width: 800px;
  }

  .content-footer-signup-wrapper {
    margin-bottom: 24px;
    padding: 0 24px;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .article-items-list {
      width: calc(100vw - 48px);
    }
  }

  .footer-disclaimer {
    font-size: 0.8125rem;
    text-align: left;
    width: 800px;
    padding: 16px 32px;
  }
`;
